import { ChevronDownIcon } from "@commonlibs";
import styled, { css } from "styled-components";
import { ExpandableIconProps } from "./ExpandableIcon";

export const ExpandableIconRoot = styled(ChevronDownIcon)<ExpandableIconProps>(
    ({ open, theme }) => css`
        font-size: 0.8rem;
        transform: rotate(${open ? "180deg" : "0deg"});
        transition: transform 0.4s;
        position: absolute;
        right: ${theme.spacing["4"]};
        top: ${theme.spacing["8"]};
    `,
);
